module.exports = __webpack_public_path__ + "static/media/BackgroundVideo.4f19f5f3.mp4";